import {ENDPOINTS} from 'constants/endpoints';
import {apiConfig} from 'libs/api/api';

/**
 * Send Amazon Pay
 */
export const sendAmazonPay = async (
    sessionId: string,
    grandTotalPrice: number,
): Promise<string> => {
    const {
        data: {amazonPayRedirectUrl},
    } = await apiConfig.instanceGusaBackend({
        baseURL: apiConfig.API_URL,
        data: {
            payment: {
                amount: grandTotalPrice,
            },
        },
        method: 'put',
        url: `${ENDPOINTS.AMAZON_SESSION_INFO({checkoutSessionId: sessionId})}`,
    });

    return amazonPayRedirectUrl;
};
